/// <amd-module name= "Core/Medius.Core.Web/Scripts/Medius/apps/task/taskValidationModalHandler" />
import { observable, pureComputed } from "knockout";
import { ValidationModal } from "Core/Medius.Core.Web/Scripts/Medius/apps/task/validationModal";
import { translate } from "Core/Medius.Core.Web/Scripts/lib/globalization";

class TaskValidationModalHandler {
    private validationModal: any;
    private IsShown: ko.Observable<boolean>;

    constructor(title: string, heading: string, content: string) {
        this.IsShown = observable(false);
        this.validationModal = pureComputed(() => {
            return {
                functionComponent: ValidationModal,
                props: {
                    isShown: this.IsShown(),
                    title: translate(title),
                    heading: translate(heading),
                    content: translate(content),
                    onClose: () => {
                        this.IsShown(false);
                    }
                }
            };
        });
    }

    public show() {
        this.IsShown(true);
    }
}

export function create(options: { title: string; heading: string; content: string }) {
    return new TaskValidationModalHandler(options.title, options.heading, options.content); 
}